import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

const FinancialContext = createContext({ revealed: false, reveal: () => {}, hide: () => {} });

const HIDE_AFTER_MS = 5 * 60 * 1000; // 5 minutes

export function FinancialProvider({ children }) {
  const [revealed, setRevealed] = useState(false);
  const timerRef = useRef(null);

  const hide = () => {
    setRevealed(false);
    if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; }
  };

  const reveal = () => {
    setRevealed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(hide, HIDE_AFTER_MS);
  };

  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current); }, []);

  return (
    <FinancialContext.Provider value={{ revealed, reveal, hide }}>
      {children}
    </FinancialContext.Provider>
  );
}

export const useFinancial = () => useContext(FinancialContext);
